(function() {
    const updateCountdown = (timer) => {
        const target = timer.getAttribute('data-disco-target-date');
        if (!target) return;

        const targetDate = new Date(target).getTime();
        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference <= 0) {
            timer.style.display = 'none';
            return;
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        const daysEl = timer.querySelector('[data-unit=\"days\"] .disco-countdown-number');
        const hoursEl = timer.querySelector('[data-unit=\"hours\"] .disco-countdown-number');
        const minutesEl = timer.querySelector('[data-unit=\"minutes\"] .disco-countdown-number');
        const secondsEl = timer.querySelector('[data-unit=\"seconds\"] .disco-countdown-number');

        if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
        if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
        if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
        if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    };

    const initCountdowns = () => {
        const timers = document.querySelectorAll('.disco-countdown-timer');
        timers.forEach((timer) => {
            updateCountdown(timer);
            setInterval(() => updateCountdown(timer), 1000);
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCountdowns);
    } else {
        initCountdowns();
    }
})();